import { Component, forwardRef, OnInit } from '@angular/core'
import { ConfigurationOptionSelectAdvancedComponent } from '../configuration-option-select-advanced/configuration-option-select-advanced.component'
import { SelectableDealOption } from 'modules/deals/utilities/deal-types'
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
    selector: 'mg-configuration-option-select-advanced-color',
    templateUrl: './configuration-option-select-advanced-color.component.html',
    styleUrls: ['./configuration-option-select-advanced-color.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfigurationOptionSelectAdvancedColorComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfigurationOptionSelectAdvancedColorComponent),
            multi: true,
        },
    ],
})
export class ConfigurationOptionSelectAdvancedColorComponent extends ConfigurationOptionSelectAdvancedComponent {
    orderedOptions() {
        const order = [
            'Solid Black',
            'Midnight Silver Metallic',
            'Stealth Grey',
            'Deep Blue Metallic',
            'Pearl White Multi-Coat',
            'Multi-Coat Red',
        ]

        return [...this.options].sort(
            (optionA, optionB) =>
                order.indexOf((optionA as SelectableDealOption).name) -
                order.indexOf((optionB as SelectableDealOption).name)
        )
    }

    trackByFn(index, item) {
        return item.id
    }
}
